import { ACCESS_STATUS, REASONS, createPolicy } from "./policy";

// Written as a bare `process.env.NODE_ENV` so the bundler can replace it and
// strip the diagnostics from production builds.
const isDev = () => process.env.NODE_ENV !== "production";

const HUMAN = {
  [REASONS.ALLOWED]: "Role holds the permission and the resource is in scope",
  [REASONS.UNAUTHENTICATED]: "No signed-in user",
  [REASONS.ACCESS_NOT_READY]: "User is still loading",
  [REASONS.UNKNOWN_ROLE]: "Role is not a known role",
  [REASONS.UNKNOWN_PERMISSION]: "Permission id is not registered",
  [REASONS.ROLE_NOT_ALLOWED]: "Permission not granted to this role",
  [REASONS.CONDITION_FAILED]: "Extra condition on the grant failed",
  [REASONS.MISSING_RESOURCE]: "Scoped permission checked without a resource id",
  [REASONS.RESOURCE_NOT_ASSIGNED]: "Resource is not assigned to this user",
  [REASONS.PACKAGE_RESTRICTED]: "Not included in this user's package",
  [REASONS.SUBSCRIPTION_REQUIRED]: "Available once the store's subscription is active",
  [REASONS.BRANCH_ASSIGNMENT_REQUIRED]: "Branch user without a valid assigned branch",
};

/**
 * Development-only: explains one decision. Returns null in production builds
 * so no policy detail can leak to end users.
 */
export const explainAccess = (identity, permission, resource) => {
  if (!isDev()) return null;
  const policy = createPolicy(identity);
  const decision = policy.evaluate(permission, resource);
  return {
    role: policy.role,
    status: policy.status,
    permission,
    restaurantId: resource?.restaurantId ?? null,
    branchId: resource?.branchId ?? null,
    decision: decision.allowed ? "ALLOWED" : "DENIED",
    reason: decision.reason,
    detail: HUMAN[decision.reason] || decision.reason,
  };
};

export const formatExplanation = (info) =>
  info &&
  [
    `Role: ${info.role ?? "-"}`,
    `Permission: ${info.permission}`,
    `Restaurant: ${info.restaurantId ?? "-"}`,
    `Branch: ${info.branchId ?? "-"}`,
    "",
    `Decision: ${info.decision}`,
    `Reason: ${info.reason} (${info.detail})`,
  ].join("\n");

/** Installs window.__ludAccess.explain(permission, resource) in dev builds. */
export const installAccessDebugger = (getIdentity) => {
  if (!isDev() || typeof window === "undefined") return;
  window.__ludAccess = {
    explain: (permission, resource) => {
      const text = formatExplanation(explainAccess(getIdentity(), permission, resource));
      // eslint-disable-next-line no-console
      console.log(text);
      return text;
    },
  };
};

export { ACCESS_STATUS };
